import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StateViewComponent } from './state-view/state-view.component';
import { MoovCommonModule } from '../moov-common/moov-common.module';
import { FamilyGaugeCardComponent } from './family-gauge-card/family-gauge-card.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FamilyDriversBreakdownWidgetComponent } from './family-drivers-breakdown-widget/family-drivers-breakdown-widget.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FamiliesGaugesWidgetComponent } from './families-gauges-widget/families-gauges-widget.component';
import { NgxGaugeModule } from 'ngx-gauge';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { CultureDetailsWidgetComponent } from './culture-details-widget/culture-details-widget.component';
import { EnergyBarWidgetComponent } from './energy-bar-widget/energy-bar-widget.component';
import { ImpactDetailsComponent } from './impact-details/impact-details.component';
import { CultureCardComponent } from './culture-card/culture-card.component';
import { CultureScoreDetailsComponent } from './culture-score-details/culture-score-details.component';
import { CultureCardListComponent } from './culture-card-list/culture-card-list.component';
import { TotalEnergyComponent } from './total-energy/total-energy.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SideNavDriverBreakdownListComponent } from './side-nav-driver-breakdown-list/side-nav-driver-breakdown-list.component';
import { CultureBreakdownComponent } from './culture-breakdown/culture-breakdown.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { CultureImpactTagComponent } from './culture-impact-tag/culture-impact-tag.component';


@NgModule({
  declarations: [
    StateViewComponent,
    FamilyGaugeCardComponent,
    FamilyDriversBreakdownWidgetComponent,
    FamiliesGaugesWidgetComponent,
    CultureDetailsWidgetComponent,
    EnergyBarWidgetComponent,
    ImpactDetailsComponent,
    CultureCardComponent,
    CultureScoreDetailsComponent,
    CultureCardListComponent,
    TotalEnergyComponent,
    SideNavDriverBreakdownListComponent,
    CultureBreakdownComponent,
    CultureImpactTagComponent,
  ],
  imports: [
    CommonModule,
    MoovCommonModule,
    NgxGaugeModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatListModule,
    MatMenuModule ,
    MatSidenavModule,
    MatButtonModule,
    MatSelectModule
  ],
})
export class StateViewModule {}
